<template>
  <div class="new_insured" v-if="visible">
    <div class="con_">
      <p>新增被保人信息</p>
      <div class="list">
        <a-form layout="horizontal" class="horizontal_item_" :form="addForm">
          <a-row class="form_con">
            <a-col :span="10" :offset="1">
              <a-form-item :label-col="{ span: 8 }" label="与投保人关系">
                <a-select
                  placeholder="请选择"
                  :default-value="addRelation"
                  :value="addRelation"
                  @change="handleChange"
                >
                  <a-select-option value="1" v-if="categoryid=='I'">本人</a-select-option>
                  <a-select-option value="99" v-if="categoryid=='C'">其他</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="10" :offset="1">
              <a-form-item :label-col="{ span: 8 }" label="姓名">
                <a-input
                  v-decorator="[
                      'addInsured.name',
                      {
                        rules: [{ required: true, message: '请输入姓名' }],
                        initialValue: addInsured.name,
                      },
                    ]"
                  placeholder="请输入姓名"
                ></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="10" :offset="1">
              <a-form-item :label-col="{ span: 8 }" label="证件类型">
                <a-select
                  @change="idTypeChange"
                  placeholder="请选择"
                  v-decorator="[
                      'addInsured.idType',
                      {
                        rules: [{ required: true, message: '请选择证件类型' }],
                        initialValue: addInsured.idType,
                      },
                    ]"
                >
                  <a-select-option value="1">身份证</a-select-option>
                  <a-select-option value="2">护照</a-select-option>
                  <a-select-option value="07">港澳台居民居住证</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="10" :offset="1">
              <a-form-item :label-col="{ span: 8 }" label="证件号码">
                <a-input
                  @blur="handleIdCardBlurProxy('addForm', 'addInsured.idType', 'addInsured.idNumber', 'addInsured.gender', 'addInsured.birthDate')"
                  v-decorator="[
                      'addInsured.idNumber',
                      {
                        rules: [
                          { required: true, message: '请输入证件号码' },
                          { validator: (rule, value, callback) => idNumberValidator(value, callback, 'addForm', 'addInsured.idType')}
                        ],
                        initialValue: addInsured.idNumber,
                      },
                    ]"
                  placeholder="请输入证件号码"
                ></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="10" :offset="1" v-if="idType == 1">
              <a-form-item :label-col="{ span: 8 }" label="是否长期有效">
                <a-select
                  @change="validityTypeChange"
                  placeholder="请选择是否长期有效"
                  v-decorator="[
                      'addInsured.isProtected',
                      {
                        rules: [{ required: true, message: '请选择证件是否长期有效' }],
                        initialValue: addInsured.isProtected,
                      },
                    ]"
                >
                  <a-select-option value="1">是</a-select-option>
                  <a-select-option value="2">否</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="10" :offset="1" v-if="idType == 1">
              <a-form-item :label-col="{ span: 8 }" label="证件有效起期">
                <a-date-picker
                  style="width: 100%;"
                  v-decorator="[
                      'addInsured.idExpiryStart',
                      {
                        rules: [{ required: true, message: '请选择证件有效起期' }],
                        initialValue: addInsured.idExpiryStart,
                      },
                    ]"
                  @change="onChangeDate"
                  placeholder="请选择证件有效起期"
                  :defaultPickerValue="minAge"
                />
              </a-form-item>
            </a-col>
            <a-col :span="10" :offset="1" v-if="(isProtected == 2&&idType == 1)||idType==2||idType=='07'">
              <a-form-item :label-col="{ span: 8 }" label="证件有效止期">
                <a-date-picker
                  style="width: 100%;"
                  v-decorator="[
                      'addInsured.idExpiryEnd',
                      {
                        rules: [{ required: true, message: '请选择证件有效止期' }],
                        initialValue: addInsured.idExpiryEnd,
                      },
                    ]"
                  @change="onChangeDate"
                  placeholder="请选择证件有效止期"
                  :defaultPickerValue="minAge"
                />
              </a-form-item>
            </a-col>
            <a-col :span="10" :offset="1">
              <a-form-item :label-col="{ span: 8 }" label="出生日期">
                <a-date-picker
                  style="width: 100%;"
                  v-decorator="[
                      'addInsured.birthDate',
                      {
                        rules: [{ required: true, message: '请选择出生日期' }],
                        initialValue: addInsured.birthDate,
                      },
                    ]"
                  @change="onChangeDate"
                  placeholder="请选择出生日期"
                  :disabledDate="disabledDate"
                  :defaultPickerValue="minAge"
                />
              </a-form-item>
            </a-col>
            <a-col :span="10" :offset="1">
              <a-form-item :label-col="{ span: 8 }" label="性别">
                <a-select
                  placeholder="请选择"
                  v-decorator="[
                      'addInsured.gender',
                      {
                        rules: [{ required: true, message: '请选择性别' }],
                        initialValue: addInsured.gender,
                      },
                    ]"
                >
                  <a-select-option
                    v-for="item in sexOptions"
                    :key="item.value"
                    :value="item.value"
                  >{{ item.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="10" :offset="1">
              <a-form-item :label-col="{ span: 8 }" label="第一年身故保额">
                <a-input
                  v-decorator="[
                      'addInsured.bdieCoverage1',
                      {
                        initialValue: addInsured.bdieCoverage1
                      },
                    ]"
                  placeholder="请输入第一年身故保额"
                ></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="10" :offset="1">
              <a-form-item :label-col="{ span: 8 }" label="第二年身故保额">
                <a-input
                  v-decorator="[
                      'addInsured.bdieCoverage2',
                      {
                        initialValue: addInsured.bdieCoverage2
                      },
                    ]"
                  :disabled="termYear < 2"
                  placeholder="请输入第二年身故保额"
                ></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="10" :offset="1">
              <a-form-item :label-col="{ span: 8 }" label="第三年身故保额">
                <a-input
                  v-decorator="[
                      'addInsured.bdieCoverage3',
                      {
                        initialValue: addInsured.bdieCoverage3
                      },
                    ]"
                  :disabled="termYear<3"
                  placeholder="请输入第三年身故保额"
                ></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="10" :offset="1">
              <a-form-item :label-col="{ span: 8 }" label="第四年身故保额">
                <a-input
                  v-decorator="[
                      'addInsured.bdieCoverage4',
                      {
                        initialValue: addInsured.bdieCoverage4
                      },
                    ]"
                  :disabled="termYear < 4"
                  placeholder="请输入第四年身故保额"
                ></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="10" :offset="1">
              <a-form-item :label-col="{ span: 8 }" label="第五年身故保额">
                <a-input
                  v-decorator="[
                      'addInsured.bdieCoverage5',
                      {
                        initialValue: addInsured.bdieCoverage5
                      },
                    ]"
                  :disabled="termYear < 5"
                  placeholder="请输入第五年身故保额"
                ></a-input>
              </a-form-item>
            </a-col>
          </a-row>
          <a-col class="btn_list" :span="24">
            <div class="btn_">
              <a class="btn_a" href="javascript:;" @click="handleClose">关闭</a>
            </div>
            <div @click="handleSubmitNew" class="btn_">
              <a class="btn_a">保存</a>
            </div>
          </a-col>
        </a-form>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.new_insured {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 100;

  .con_ {
    border-radius: 8px;
    width: 800px;
    padding: 20px;
    background-color: #fff;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 0;
    right: 0;
    margin: 0 auto;

    > p {
      font-weight: bold;
    }

    .btn_list {
      display: flex;
    }
  }
}

.btn_list {
  display: flex;
  justify-content: center;

  .btn_ {
    margin: 19px;
    border: 1px solid rgba(254, 143, 45, 1);
    width: 150px;
    height: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;

    .btn_a {
      flex: 1;
      text-align: center;
      color: rgba(254, 143, 45, 1);
    }
  }
}

@media screen and (max-width: 500px) {
  .new_insured .con_ {
    .ant-col-12 {
      width: 100%;
    }

    width: 95vw !important;

    .form_con {
      height: 78vh;
      position: relative;
      overflow-y: scroll;
    }
  }

  .btn_list .btn_ {
    margin: 5px;
  }
}
</style>
<script>
// import dictOptions from "@/utils/dictOptions";
const dictOptions = window.utilsdictOptions;
import validatorMixin from "@/mixins/validator";
import moment from "moment";
export default {
  props: {
    publicParms: {
      type: Object,
      default: () => ({
        effectiveDate: ""
      })
    },
    visible: {
      type: Boolean,
      default: false
    },
    categoryid: {
      type: String,
      default: ""
    },
    operation: {
      type: String,
      default: ""
    },
    fieldHidedKeys: {
      type: Array,
      default: () => {
        return ["occulevel", "occupationCode"];
      }
    }
  },
  watch: {
    editingInfo: {
      handler() {
        this.addInsured = JSON.parse(JSON.stringify(this.editingInfo));
        this.idType = this.editingInfo.idType;
        this.isProtected = this.editingInfo.isProtected;
      },
      deep: true //true 深度监听
    },
    categoryid: function(val) {
      let relation = val == "I" ? "1" : "99";
      this.addRelation = relation;
      this.addForm.setFieldsValue({
        addInsured: {
          relation: relation
        }
      });
    }
  },
  data() {
    this.handleIdCardBlurProxy = this.handleIdCardBlur.bind(this);
    return {
      addForm: this.$form.createForm(this),
      occupationList: [],
      occupationOptionsLevel: [],
      editingInfo:{},
      addInsured: {},
      termYear:"",
      sexOptions: dictOptions.sexOptions,
      IdTypeOptions: dictOptions.idTypeOptions,
      addRelation: "99",
      ywbm:5,
      idType: "",
      isProtected: "",
      nationalityList: [
        { value: "1", text: "境内" },
        { value: "0", text: "境外" }
      ],
      minAge: moment().subtract(16, "years")
    };
  },
  mixins: [validatorMixin],
  mounted() {
    this.effectiveDate = this.publicParms.effectiveDate;
    this.addInsured = JSON.parse(JSON.stringify(this.editingInfo));
    this.$bus.$on("busTermYear", (data,ywbm) => {
      
      this.termYear = data
      this.ywbm = ywbm
    });
    this.$bus.$on("busEditingInsuredInfo", data => {
      this.editingInfo = {...data}
    });
    
  },
  beforeDestroy() {
    this.$bus.$off("busPublicParms");
  },
  methods: {
    moment,
    handleChange(value) {
      this.addRelation = value;
    },
    handleIdCardBlurProxy() {},
    handleIdCardBlur (formName = 'form', 
        idTypeName = 'idType', idNumberName = 'idNumber', 
        gender = 'gender', birthDate = 'birthDate') {
      // 填完身份证根据身份证自动带出生日跟性别
      const type = this[formName].getFieldValue(idTypeName);
      const value = this[formName].getFieldValue(idNumberName);

      if (this.checkIdNumber(value) && (type == "1" || type == "07")) {
        const { birth, sex } = this.calcBGByIdCardNumber(value);
        this[formName].setFieldsValue({
          [gender]: sex,
          [birthDate]: moment(birth)
        })
      }
    },
    onChangeDate(date, dateString) {
      let item = this.addInsured;
      let _this = this;
      if (item.idType == "1") {
        if (item.idNumber) {
          let result = this.calcBGByIdCardNumber(item.idNumber);
          if (result.birthDate != dateString) {
            _this.$message.warning("身份证信息与生日选择不符");
            _this.addForm.setFieldsValue({
              addInsured: {
                birthDate: null
              }
            });
            this.addInsured.birthDate = null;
          }
        }
      }
    },
    disabledDate(current) {
      const minAge = moment().subtract(18, "years");
      const maxAge = moment().subtract(70, "years");
      return current && (current > minAge || current < maxAge);
    },
    idTypeChange(val) {
      this.addForm.setFieldsValue({ addInsured: { idNumber: "" } });
      this.idType = val;
    },
    validityTypeChange(val) {
      this.isProtected = val;
      this.addInsured.idExpiryEnd = "";
      this.addForm.setFieldsValue({ addInsured: { idExpiryEnd: "" } });
    },
    occuLevelChange(value) {
      //职业类别改变时确定 职业名称选择范围
      this.occupationList = this.occupationOptions.filter(
        item => item.occulevel == value
      );
      this.addForm.setFieldsValue({ addInsured: { occupationCode: "" } });
    },
    handleClose() {
      this.editingInfo = {};
      this.$emit("update:visible", false);
    },
    displayAge(birth, target) {
      //判断年龄
      let months = target.diff(birth, "months", true);
      let birthSpan = {
        year: Math.floor(months / 12),
        month: Math.floor(months) % 12,
        day: Math.round((months % 1) * target.daysInMonth(), 0)
      };
      return birthSpan.year;
    },
    handleSubmitNew(e) {
      e.preventDefault();
      this.addForm.validateFields((err, values) => {
        if (!err) {
          let ageType;
          let years;
          let effectiveDate = this.publicParms.effectiveDate;
          let idExpiryEnd;
          let nationality;
          // 校验姓名不能含有数字
          if (values.addInsured.name) {
            let reg = /\d/g;
            if (reg.test(values.addInsured.name)) {
              this.$message.warning(`被保人姓名中不能含有数字`, 6);
              return;
            }
          }
          if (values.addInsured.birthDate) {
            years = this.displayAge(
              moment(values.addInsured.birthDate),
              moment(effectiveDate)
            );
            if (years < 18 || years > 70) {
              this.$message.warning(`18岁以下及超过70周岁，不予承保`, 6);
              return;
            }
            if (years > 65) {
              ageType = 1;
            }
          }
         

          if (values.addInsured.isProtected == 1 && values.addInsured.idType == 1) {
            idExpiryEnd = "9999-01-01";
          } else {
            idExpiryEnd = values.addInsured.idExpiryEnd
              ? moment(values.addInsured.idExpiryEnd).format("YYYY-MM-DD")
              : "";
          }
          if (values.addInsured.idType == "2") {
            nationality = 0;
          } else {
            nationality = 1;
          }
          this.addInsured = {
            //x每次新增的被保人
            ...values.addInsured,
            beneficialType: "1", // 固定值
            type: "C", // 固定值
            relationship: "99",
            ageType,
            years,
            nationality,
            idExpiryStart: values.addInsured.idExpiryStart
              ? moment(values.addInsured.idExpiryStart).format("YYYY-MM-DD")
              : "",
            idExpiryEnd,
            birthDate: moment(values.addInsured.birthDate).format("YYYY-MM-DD"),
            uniqueid: "", //被保人保额//下面算
            relation: this.addRelation,
            occupationName: "", //下面
            occupationCode: values.addInsured.occupationCode
          };
          this.$emit("change", {
            type: this.operation,
            data: this.addInsured
          });
          this.addInsured = {};
          this.editingInfo = {};
          this.addForm.resetFields();
          this.handleClose();
        }
      });
    }
  }
};
</script>